import React from "react";
import Countdown from "react-countdown";
import { zeroPad } from "../../util/util";
import { Box, Flex } from "reflexbox/styled-components";
import styled from "styled-components";
import { withLocalizeStrings } from "../../languages/Localize";
import { useApplicationStateValue } from "../../application/Application";

const StyledTimerContainer = styled(Box).attrs(() => ({ width: "100%" }))`
    display: grid;
    grid-template-columns: 0 19% 19% 19% 19% 19%;
    grid-column-gap: 1%;
    grid-template-rows: max-content auto;
    color: ${({ theme }) => theme.colors.white};
    margin-top: 28vh;
`;
const StyledTimeUnitNumber = styled(Flex).attrs(() => ({ fontSize: [7, 8, 8], fontWeight: "normal" }))`
    width: 100%;
    justify-content: space-around;
    align-items: center;
    line-height: 1;
`;

const StyledTimeUnitLabel = styled(Flex).attrs(() => ({ fontSize: [1, 2, 2], fontWeight: "light" }))`
    width: 100%;
    justify-content: center;
    align-items: flex-start;
`;

const ForumCountdown = ({ to, strings }) => {
    const { setStarted } = useApplicationStateValue();
    const renderer = ({ days, hours, minutes, seconds, completed }) => {
        let weeks = Math.ceil(days / 7);
        weeks = weeks > 0 ? weeks - 1 : weeks;
        if (completed) {
            setStarted(true);
            return null;
        } else
            return (
                <StyledTimerContainer paddingX={[4, 5]}>
                    <StyledTimeUnitNumber />
                    <StyledTimeUnitNumber>{zeroPad(weeks)}</StyledTimeUnitNumber>
                    <StyledTimeUnitNumber>{zeroPad(days % 7)}</StyledTimeUnitNumber>
                    <StyledTimeUnitNumber>{zeroPad(hours)}</StyledTimeUnitNumber>
                    <StyledTimeUnitNumber>{zeroPad(minutes)}</StyledTimeUnitNumber>
                    <StyledTimeUnitNumber>{zeroPad(seconds)}</StyledTimeUnitNumber>
                    <StyledTimeUnitLabel />
                    <StyledTimeUnitLabel>{strings.home.WEEKS}</StyledTimeUnitLabel>
                    <StyledTimeUnitLabel>{strings.home.DAYS}</StyledTimeUnitLabel>
                    <StyledTimeUnitLabel>{strings.home.HOURS}</StyledTimeUnitLabel>
                    <StyledTimeUnitLabel>{strings.home.MINUTES}</StyledTimeUnitLabel>
                    <StyledTimeUnitLabel>{strings.home.SECONDS}</StyledTimeUnitLabel>
                </StyledTimerContainer>
            );
    };
    return <Countdown date={to} renderer={renderer} />;
};

export default withLocalizeStrings(ForumCountdown);
